// extracted by mini-css-extract-plugin
module.exports = {"root":"CallDirection_root__3UIT2","inCall":"CallDirection_inCall__1TDfX","outCall":"CallDirection_outCall__1ogqZ","icon":"CallDirection_icon__3CzoH"};